import PublicNav from "@/components/PublicNav";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function LegalPage({ title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-slate-50">
      <PublicNav />
      <section className="max-w-4xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
        <Link to="/" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-teal-700 mb-6">
          <ChevronLeft className="h-4 w-4" /> العودة للرئيسية
        </Link>
        <div className="text-xs font-bold uppercase tracking-widest text-amber-600 mb-3">{subtitle}</div>
        <h1 className="text-4xl lg:text-5xl font-heading font-black text-slate-900 leading-tight">{title}</h1>
        <div className="mt-10 prose prose-slate max-w-none leading-loose text-slate-700 space-y-4">
          {children}
        </div>
      </section>
    </div>
  );
}

export function Terms() {
  return (
    <LegalPage title="الشروط والأحكام" subtitle="اتفاقية الاستخدام">
      <p>يُنظّم هذا المستند علاقتك بعماد كطالب متدرب أو جمعية أو موجّه أو معدّ محتوى أو مؤسسة مانحة أو جهة استقطاب أو عضو هيئة تدريس أو مدير نظام. باستخدامك للمنصة، فإنك توافق على هذه الشروط.</p>
      <h3 className="font-heading font-bold text-slate-900 text-xl mt-8">1. الاستخدام المقبول</h3>
      <p>تستخدم المنصة لأغراض التأهيل المهني والتدريب فقط. يُحظر إساءة الاستخدام، أو محاولة اختراق النظام، أو استخدام بيانات المستفيدين الآخرين دون تصريح.</p>
      <h3 className="font-heading font-bold text-slate-900 text-xl mt-8">2. الملكية الفكرية</h3>
      <p>كل المحتوى التدريبي والمقررات والاختبارات ملكية للمنصة أو معدّيها. لا يجوز نسخها أو إعادة نشرها دون إذن.</p>
      <h3 className="font-heading font-bold text-slate-900 text-xl mt-8">3. الشهادات</h3>
      <p>تُصدر الشهادات عند استيفاء جميع متطلبات البرنامج. يمكن التحقق من صحّة أي شهادة عبر الرابط العام الخاص بها.</p>
      <h3 className="font-heading font-bold text-slate-900 text-xl mt-8">4. حق التعديل</h3>
      <p>يحقّ لإدارة المنصة تعديل هذه الشروط في أي وقت. سيتم إخطار المستخدمين بأي تغييرات جوهرية.</p>
    </LegalPage>
  );
}

export function Privacy() {
  return (
    <LegalPage title="سياسة الخصوصية" subtitle="حماية بياناتك">
      <p>تحرص عماد على حماية بيانات المستفيدين ومعالجتها بشكل مسؤول. توضّح هذه السياسة أنواع البيانات التي نجمعها وكيف نستخدمها.</p>
      <h3 className="font-heading font-bold text-slate-900 text-xl mt-8">البيانات المجمّعة</h3>
      <p>الاسم، البريد الإلكتروني، رقم الجوال، المدينة، بيانات الملف التعليمي والمهني، ونتائج التعلّم والتقييم.</p>
      <h3 className="font-heading font-bold text-slate-900 text-xl mt-8">استخدام البيانات</h3>
      <p>تُستخدم البيانات لإدارة رحلة التدريب، تمكين الجمعيات والموجّهين من المتابعة، وإصدار الشهادات، بالإضافة إلى قياس الأثر بشكل مجمّع للمؤسسات المانحة.</p>
      <h3 className="font-heading font-bold text-slate-900 text-xl mt-8">لا نشارك بياناتك الشخصية</h3>
      <p>لا نبيع أو نُشارك بياناتك الشخصية مع أطراف ثالثة لأغراض تسويقية. أي مشاركة تكون فقط في سياق تشغيل المنصة (الجمعية، الموجّه).</p>
      <h3 className="font-heading font-bold text-slate-900 text-xl mt-8">حقوقك</h3>
      <p>يمكنك طلب تعديل أو حذف بياناتك في أي وقت عبر بريد الدعم.</p>
    </LegalPage>
  );
}

export function Contact() {
  return (
    <LegalPage title="تواصل معنا" subtitle="نحن هنا للمساعدة">
      <p>سعداء بتواصلك مع فريق عماد لأي استفسار أو طلب انضمام كشريك.</p>
      <div className="grid md:grid-cols-2 gap-6 mt-10 not-prose">
        <div className="p-4 rounded-2xl bg-white border border-cream-200">
          <div className="text-xs font-bold text-teal-700 uppercase mb-2">البريد الإلكتروني</div>
          <div className="font-heading font-bold text-slate-900 text-lg" dir="ltr">emad-os@siaq-sa.com</div>
        </div>
        <div className="p-4 rounded-2xl bg-white border border-cream-200">
          <div className="text-xs font-bold text-teal-700 uppercase mb-2">الدعم والمساعدة</div>
          <div className="font-heading font-bold text-slate-900 text-lg mb-2">افتح تذكرة دعم</div>
          <p className="text-sm text-slate-600 mb-4">إذا واجهتك مشكلة تقنية أو تحتاج مساعدة في استخدام المنصة، افتح تذكرة وسنرد عليك خلال يوم عمل.</p>
          <Link to="/dashboard/support" className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-teal-700 text-white text-sm font-semibold hover:bg-teal-600">
            فتح مركز الدعم →
          </Link>
        </div>
        <div className="p-4 rounded-2xl bg-white border border-cream-200 md:col-span-2">
          <div className="text-xs font-bold text-teal-700 uppercase mb-2">العنوان</div>
          <div className="font-heading font-bold text-slate-900 text-lg">مكة المكرمة، المملكة العربية السعودية</div>
        </div>
      </div>
    </LegalPage>
  );
}

export function FAQ() {
  const qs = [
    { q: "من يمكنه التسجيل في عماد؟", a: "الطلاب المتدربون الباحثون عن فرصة تدريب تعاوني. الجمعيات والموجّهون ومعدّو المحتوى والمؤسسات المانحة وجهات الاستقطاب وأعضاء هيئة التدريس يُقدّمون طلب انضمام كشريك." },
    { q: "كيف تعمل رحلة الطالب المتدرب؟", a: "التسجيل → استكمال الملف → التقديم على فرصة تدريب تعاوني → القبول والتسكين داخل منظمة → برنامج الإعداد والتهيئة → المهام التطبيقية → الجلسات الإرشادية → تقارير الأداء → شهادة الإنجاز." },
    { q: "هل الشهادة موثّقة؟", a: "نعم — كل شهادة تحمل رمز QR للتحقق العام، ويمكن لأي جهة التأكد من صحّتها بمسح الرمز أو زيارة الرابط." },
    { q: "هل هناك رسوم على المنصة؟", a: "التسجيل والاستفادة من فرص التدريب التعاوني مجانية للطلاب والمنظمات (الجمعيات، الشركات غير الربحية، الجهات الحكومية) برسوم رمزية بعد انتهاء فترة التجربة." },
    { q: "كيف تُقيَّم الجلسات مع الموجّه؟", a: "يجدول الموجّه جلسات دورية معك، ويكتب ملاحظاته بعد كل جلسة. تظهر لك الملاحظات في لوحتك مباشرة." },
  ];
  return (
    <LegalPage title="الأسئلة الشائعة" subtitle="نجيب على استفساراتك">
      <div className="not-prose space-y-4 mt-8">
        {qs.map((item, i) => (
          <details key={i} className="p-4 rounded-2xl bg-white border border-cream-200 group">
            <summary className="font-heading font-bold text-slate-900 cursor-pointer list-none flex items-center justify-between">
              <span>{item.q}</span>
              <span className="text-teal-700 text-xl group-open:rotate-45 transition-transform">+</span>
            </summary>
            <p className="mt-4 text-slate-700 leading-loose">{item.a}</p>
          </details>
        ))}
      </div>
    </LegalPage>
  );
}
